import { parseDigits } from '@/utils';

export const formatPhone = (value: string) => {
  let numericValue = parseDigits(value);

  if (numericValue.startsWith('55') && numericValue.length > 11) {
    numericValue = numericValue.slice(2);
  }

  const len = numericValue.length;

  if (len > 10) {
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2, 7)}-${numericValue.slice(7, 11)}`;
  }

  if (len > 6) {
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2, 6)}-${numericValue.slice(6, 10)}`;
  }

  if (len > 2) {
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2, 6)}`;
  }

  return numericValue;
};
